import { defineComponent as _defineComponent } from 'vue';
import { validate } from '@/utils';
import { ACTIONS_COL } from '@/types/interfaces';
import { DATE_EXPIRED } from '@/constants/icons';
export default /*#__PURE__*/_defineComponent({
  __name: 'headers',
  props: {
    fontSize: {
      default: 'lg'
    },
    border: {
      type: Boolean
    },
    headers: null,
    canSelect: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    canExpand: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const {
      isEllipses
    } = validate;
    const getFontSize = size => {
      if (size === 'sm') return 3;
      if (size === 'md') return 2;
      if (size === 'lg') return 1;
      return 0;
    };
    const getHeaderClass = header => {
      return header.visibility;
    };
    return {
      __sfc: true,
      isEllipses,
      getFontSize,
      getHeaderClass,
      ACTIONS_COL,
      DATE_EXPIRED
    };
  }
});